import { LocationSelector } from '@/components/form/location-selector'

export const Location = () => {
  return <LocationSelector />
}
